export default "__VITE_ASSET__DNMN6Zvt__"